import { FC, ReactNode, useState } from 'react';
import * as React from 'react';

import './index.scss';

interface ITooltip {
    children: ReactNode;
    message: string;
    position?: 'top' | 'bottom' | 'left' | 'right';
    timeClose?: number;
    trigger?: 'click' | 'mouseover';
}

type TooltipProps = ITooltip;

const Tooltip: FC<TooltipProps> = ({ children, message, trigger = 'click', position = 'top', timeClose = 2000 }) => {
    const [displayTooltip, setDisplayTooltip] = useState<boolean>(false);

    const handleEvent = (e: React.MouseEvent) => {
        if (e.type === trigger) {
            setDisplayTooltip(true);

            if (trigger === 'click') {
                setTimeout(() => setDisplayTooltip(false), timeClose);
            }
        }
    };

    const handleEventClose = () => {
        if (trigger === 'mouseover') {
            setDisplayTooltip(false);
        }
    };

    return (
        <span className="tooltip" onMouseLeave={handleEventClose}>
            {displayTooltip && (
                <div className={`tooltip-bubble tooltip-${position}`}>
                    <div className="tooltip-message">{message}</div>
                </div>
            )}

            <span className="tooltip-trigger" onMouseOver={handleEvent} onClick={handleEvent}>
                {children}
            </span>
        </span>
    );
};

export default Tooltip;
